import { PageLayout } from '@/layouts/page-layout'
import { GroupInput } from '@/components/v2/group-input'
import { Form, Formik } from 'formik'
import { Input, Button } from '@material-tailwind/react'
import { Link, useLoaderData, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AddressForm } from '@/components/address-form'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useCreateOfficeMutation } from '@/store/services'
import { list } from '@/router/utils'
import { useAuthorization } from '@/hooks'

export const OfficeCreate = () => {
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })
  const [createOffice, { isLoading, isSuccess }] = useCreateOfficeMutation()
  const [citiesData, currentOfficeData] = useLoaderData()
  const {
    data: { cities }
  } = citiesData
  const navigate = useNavigate()
  const { t } = useTranslation()

  const defaultInitialValues = {
    name: '',
    address_attributes: {
      street: '',
      state_id: null
    },
    person_in_charge: {
      full_name: '',
      email: ''
    }
  }

  // states
  const onSubmit = async (params) => {
    createOffice(params)
  }

  useEffect(() => {
    if (isSuccess) {
      navigate(list('offices'))
    }
  }, [isSuccess])

  useEffect(() => {
    hasAccess('office#create')
  }, [])

  return (
    <PageLayout
      title={t('actions.create.with', {
        what: t('office.one').toLowerCase()
      })}
    >
      <Formik
        initialValues={defaultInitialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ values, handleChange }) => (
          <Form>
            <GroupInput divider={false} title='General' description='Rellena con la información de a dependencia y su responsable'>
              <div className='grid grid-cols-2 gap-4'>
                <Input
                  required
                  name='name'
                  label='Nombre de la dependencia'
                  value={values.name}
                  onChange={handleChange}
                />

                <AddressForm
                  required
                  cities={cities}
                  currentResource={currentOfficeData?.data?.office || {}}
                />

                <Input
                  name='person_in_charge.full_name'
                  label={t('office.personInCharge.fullName')}
                  value={values.person_in_charge.full_name}
                  onChange={handleChange}
                />

                <Input
                  name='person_in_charge.email'
                  label={t('office.personInCharge.email')}
                  value={values.person_in_charge.email}
                  onChange={handleChange}
                />

              </div>
            </GroupInput>

            <div className='flex justify-end gap-3 mt-10'>
              <Link to={list('offices')}>
                <Button variant='text' type='submit'>
                  {t('actions.cancel')}
                </Button>
              </Link>

              <Button type='submit' loading={isLoading}>
                {t('actions.create.one')}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </PageLayout>
  )
}

OfficeCreate.propTypes = {
  editMode: PropTypes.bool.isRequired
}

OfficeCreate.defaultProps = {
  editMode: false
}
